let guideEffectTimeout = null;
import { driver } from "driver.js";

export function showGuideEffect() {
  clearTimeout(guideEffectTimeout); // 清理之前的定时器

  guideEffectTimeout = setTimeout(() => {
    const paths = document.querySelectorAll("path");
    const click = document.querySelector(".click_anime");
    const popover1 = document.querySelector(".prompt_box1");

    if (!paths.length || !click) return;

    paths.forEach((path) => {
      if (path) {
        path.classList.add("show-path");
      }
    });
    click.classList.add("isShow");

    // 优化隐藏效果
    if (popover1) {
      popover1.style.animation = "slideInFromRight 1s ease forwards"; // 应用从右向左的动画
    }
  }, 4000);
}
export function initializeGuide(elementId, indexClass) {
  const index = document.querySelector(`${indexClass}`);

  // 定义 driverHelper.js 的引导配置
  const driverObj = driver({
    allowClose: false,
    showProgress: true,
    steps: [
      {
        element: `${elementId}`, // 高亮的目标元素
      },
    ],
    onHighlightStarted: () => {
      const observer = new MutationObserver(() => {
        const highlightOverlay = document.querySelector(".driver-overlay");
        if (highlightOverlay && index) {
          const indexRect = index.getBoundingClientRect();
          // 使用 clip-path 定义遮罩区域
          highlightOverlay.style.clipPath = `inset(${indexRect.top}px ${
            window.innerWidth - indexRect.right
          }px ${window.innerHeight - indexRect.bottom}px ${indexRect.left}px)`;
          // 添加 pointer-events: none，避免遮罩层拦截点击
          highlightOverlay.style.pointerEvents = "none";
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    },
  });

  // 启动引导
  driverObj.drive();

  // 2秒后显示遮罩和手指
  showGuideEffect();

  return driverObj;
}










// 带边框的引导效果
export function BorderShowGuideEffect() {
  clearTimeout(guideEffectTimeout); // 清理之前的定时器

  guideEffectTimeout = setTimeout(() => {
    const paths = document.querySelectorAll("path");
    const clickAnime = document.querySelector(".click_anime");
    const clickElement = document.querySelector(".click"); // 获取实际元素，而非伪元素

    const popover1 = document.querySelector(".prompt_box1");

    if (!paths.length || !clickAnime) return;

    paths.forEach((path) => {
      if (path) {
        path.classList.add("show-path");
      }
    });
    clickAnime.classList.add("isShow");
    clickElement.classList.add("clickShow"); // 添加类来控制伪元素显示


    // 优化隐藏效果
    if (popover1) {
      popover1.style.animation = "slideInFromRight 1s ease forwards"; // 应用从右向左的动画
    }
  }, 4000);
}
export function BorderInitializeGuide(elementId, indexClass) {
  const index = document.querySelector(`${indexClass}`);

  // 定义 driverHelper.js 的引导配置
  const driverObj = driver({
    allowClose: false,
    showProgress: true,
    steps: [
      {
        element: `${elementId}`, // 高亮的目标元素
      },
    ],
    onHighlightStarted: () => {
      const observer = new MutationObserver(() => {
        const highlightOverlay = document.querySelector(".driver-overlay");
        if (highlightOverlay && index) {
          const indexRect = index.getBoundingClientRect();
          // 使用 clip-path 定义遮罩区域
          highlightOverlay.style.clipPath = `inset(${indexRect.top}px ${
            window.innerWidth - indexRect.right
          }px ${window.innerHeight - indexRect.bottom}px ${indexRect.left}px)`;
          // 添加 pointer-events: none，避免遮罩层拦截点击
          highlightOverlay.style.pointerEvents = "none";
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    },
  });

  // 启动引导
  driverObj.drive();

  // 2秒后显示遮罩和手指
  BorderShowGuideEffect();

  return driverObj;
}
export function BorderStopGuide(driverObj) {
  if (driverObj) {
    driverObj.destroy();
    const paths = document.querySelectorAll("path.show-path");
    paths.forEach((path) => path.classList.remove("show-path"));
    const clickElement = document.querySelector(".click"); // 获取实际元素，而非伪元素
    if (clickElement) {
      clickElement.classList.remove("clickShow");
    }
    const clickAnime = document.querySelector(".click_anime");
    if (clickAnime) {
      clickAnime.classList.remove("isShow");
    }
  }
}












// 带边框无遮罩的引导效果
export function BorderNOpashShowGuideEffect() {
  clearTimeout(guideEffectTimeout); // 清理之前的定时器

  guideEffectTimeout = setTimeout(() => {
    const paths = document.querySelectorAll("path");
    const clickAnime = document.querySelector(".click_anime");
    const clickElement = document.querySelector(".click"); // 获取实际元素，而非伪元素

    const popover1 = document.querySelector(".prompt_box1");

    if (!paths.length || !clickAnime) return;

    // paths.forEach((path) => {
    //   if (path) {
    //     path.classList.add("show-path");
    //   }
    // });
    clickAnime.classList.add("isShow");
    clickElement.classList.add("clickShow"); // 添加类来控制伪元素显示


    // 优化隐藏效果
    if (popover1) {
      popover1.style.animation = "slideInFromRight 1s ease forwards"; // 应用从右向左的动画
    }
  }, 4000);
}
export function BorderNOpashInitializeGuide(elementId, indexClass) {
  const index = document.querySelector(`${indexClass}`);

  // 定义 driverHelper.js 的引导配置
  const driverObj = driver({
    allowClose: false,
    showProgress: true,
    steps: [
      {
        element: `${elementId}`, // 高亮的目标元素
      },
    ],
    onHighlightStarted: () => {
      const observer = new MutationObserver(() => {
        const highlightOverlay = document.querySelector(".driver-overlay");
        if (highlightOverlay && index) {
          const indexRect = index.getBoundingClientRect();
          // 使用 clip-path 定义遮罩区域
          highlightOverlay.style.clipPath = `inset(${indexRect.top}px ${
            window.innerWidth - indexRect.right
          }px ${window.innerHeight - indexRect.bottom}px ${indexRect.left}px)`;
          // 添加 pointer-events: none，避免遮罩层拦截点击
          highlightOverlay.style.pointerEvents = "none";
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    },
  });

  // 启动引导
  driverObj.drive();

  // 2秒后显示遮罩和手指
  BorderNOpashShowGuideEffect();

  return driverObj;
}
export function BorderNOpashStopGuide(driverObj) {
  if (driverObj) {
    driverObj.destroy();
    // const paths = document.querySelectorAll("path.show-path");
    // paths.forEach((path) => path.classList.remove("show-path"));
    const clickElement = document.querySelector(".click"); // 获取实际元素，而非伪元素
    if (clickElement) {
      clickElement.classList.remove("clickShow");
    }
    const clickAnime = document.querySelector(".click_anime");
    if (clickAnime) {
      clickAnime.classList.remove("isShow");
    }
  }
}

















// 显示遮罩和手指，没有隐藏提示
export function fastShowGuideEffect() {
  clearTimeout(guideEffectTimeout); // 清理之前的定时器

  guideEffectTimeout = setTimeout(() => {
    const paths = document.querySelectorAll("path");
    const click = document.querySelector(".click_anime");
    const popover1 = document.querySelector(".prompt_box1");

    if (!paths.length || !click) return;

    paths.forEach((path) => {
      if (path) {
        path.classList.add("show-path");
      }
    });
    click.classList.add("isShow");

    // 优化隐藏效果
    if (popover1) {
      popover1.style.animation = "slideInFromRight 1s ease forwards"; // 应用从右向左的动画
    }
  }, 0);
}
// 显示遮罩和手指，没有隐藏提示
export function fastInitializeGuide(elementId, indexClass) {
  const index = document.querySelector(`${indexClass}`);

  // 定义 driverHelper.js 的引导配置
  const driverObj = driver({
    allowClose: false,
    showProgress: true,
    steps: [
      {
        element: `${elementId}`, // 高亮的目标元素
      },
    ],
    onHighlightStarted: () => {
      const observer = new MutationObserver(() => {
        const highlightOverlay = document.querySelector(".driver-overlay");
        if (highlightOverlay && index) {
          const indexRect = index.getBoundingClientRect();
          // 使用 clip-path 定义遮罩区域
          highlightOverlay.style.clipPath = `inset(${indexRect.top}px ${
            window.innerWidth - indexRect.right
          }px ${window.innerHeight - indexRect.bottom}px ${indexRect.left}px)`;
          // 添加 pointer-events: none，避免遮罩层拦截点击
          highlightOverlay.style.pointerEvents = "none";
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    },
  });

  // 启动引导
  driverObj.drive();

  // 2秒后显示遮罩和手指
  fastShowGuideEffect();

  return driverObj;
}

export function stopGuide(driverObj) {
  if (driverObj) {
    driverObj.destroy();
    const paths = document.querySelectorAll("path.show-path");
    paths.forEach((path) => path.classList.remove("show-path"));
    const click = document.querySelector(".click_anime");
    if (click) {
      click.classList.remove("isShow");
    }
  }
}
